import { ReactNode } from 'react'
import { Box, Typography, TypographyProps } from '@mui/material'

import MainContainer from '@ecm/ui/element/MainContainer'

type FeaturesContainerProps = {
  children: ReactNode
  header?: string
  headingMaxWidth?: TypographyProps['maxWidth']
}

const FeaturesContainer = ({
  children,
  header,
  headingMaxWidth = '400px',
}: FeaturesContainerProps) => (
  <Box
    p={{ md: '8em 0 5em', xs: '4em 0 2em' }}
    bgcolor="#050F37"
    position="relative"
    zIndex="1"
    sx={{
      '&:after': {
        background: "url('/images/icon/bg_lines_2.svg') no-repeat bottom left",
        backgroundSize: 'contain',
        bottom: 0,
        left: 0,
      },
      '&:after, &:before': {
        content: "''",
        height: '100%',
        position: 'absolute',
        width: '70%',
        zIndex: '-1',
      },
      '&:before': {
        background: "url('/images/icon/bg_lines_1.svg') no-repeat top right",
        backgroundSize: 'contain',
        right: 0,
        top: 0,
      },
    }}
  >
    <MainContainer>
      <Typography
        variant="h3"
        component="h2"
        mb="1em"
        maxWidth={headingMaxWidth}
        sx={{
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundImage: 'linear-gradient(94.6deg, #00E3FF 0%, #4EDF97 110.42%);',
        }}
      >
        {header ?? 'Let’s take a look at some cool features'}
      </Typography>
      {children}
    </MainContainer>
  </Box>
)

export default FeaturesContainer
